class Popup extends BaseElement
{
  init ()
  {
    this.body = this.querySelector('.popup-body');
    this.closeBtn = this.querySelector('custom-popup-close');

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    if (this.body) {
      this.body.addEventListener('click', e => e.stopPropagation());
    }

    this.addEventListener('click', () => {
      if (typeof(this.dataset.preventClose) === 'undefined') {
        this.close();
      }
    });
  }

  close ()
  {
    this.classList.remove('show');

    document.body.classList.remove('showing-popup');
  }

  open ()
  {
    this.classList.add('show');

    document.body.classList.add('showing-popup');
  }

  isOpen ()
  {
    return this.classList.contains('show');
  }
}

if (!customElements.get('custom-popup')) {
  customElements.define('custom-popup', Popup);
}

const initCustomPopups = () => {
  document.querySelectorAll('[data-custom-popup]:not(.custom-popup-initialized)').forEach(div => {
    div.classList.add('custom-popup-initialized');
    div.addEventListener('click', e => {
      e.preventDefault();

      const popup = document.querySelector(div.dataset.customPopup);

      if (popup) {
        // close other
        document.querySelectorAll('custom-popup').forEach(pop => pop.isOpen() ? pop.close() : null);

        popup.open();

        broadcast('popupOpen', popup);
      }
    });
  });
};

initCustomPopups();